import { render, staticRenderFns } from "./list-pro.vue?vue&type=template&id=dd9ee24e&scoped=true"
import script from "./list-pro.vue?vue&type=script&lang=js"
export * from "./list-pro.vue?vue&type=script&lang=js"
import style0 from "./list-pro.vue?vue&type=style&index=0&id=dd9ee24e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9ee24e",
  null
  
)

export default component.exports